/*
 * Code is being shared for FAQs & Content Accordion blocks
 */
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    if (!event.target.matches(".faq-title")) return;
    event.target.classList.toggle("opened");
    event.target.parentNode.classList.toggle("opened");
    event.target.classList.contains("opened") ? event.target.ariaExpanded = "true" : event.target.ariaExpanded = "false";
  });
});